import React from 'react'
import { Header, Button, Form, Modal } from 'semantic-ui-react';
import Loader from '../../sharedComponent/loader/loader';

const PunchesModal = (props) => {
    return (
        <Modal open={props.isShowPunchesModal} closeOnDimmerClick={false} size='tiny'>
            <Modal.Header className="text-center">Enter Punches</Modal.Header>
            <Modal.Content className="overflowVisible" scrolling style={{ minHeight: "auto" }}>
                <Header as='h5' className="text-center" size="tiny">All Times are in 24 Hours Format</Header>
                <Form>
                    <Form.Group className='mb-2 startLunchTime'>
                        <Form.Input disabled={true} className='modalInput text-center' label='Start Time' placeholder='Start Time' width={8} value={props.selectedTimeCardPunches.startTime} />
                        <Form.Input disabled={true} className='modalInput text-center' label='End Time' placeholder='End Time' width={8} value={props.selectedTimeCardPunches.endTime} />
                    </Form.Group>
                    <Form.Group className='mb-2 startLunchTime'>
                        <Form.Input disabled={true} className='modalInput text-center' label='Lunch Start' placeholder='Lunch Start Time' width={8} value={props.selectedTimeCardPunches.lunchStartTime} />
                        <Form.Input disabled={true} className='modalInput text-center' label='Lunch End' placeholder='Lunch End Time' width={8} value={props.selectedTimeCardPunches.lunchEndTime} />
                    </Form.Group>
                </Form>
            </Modal.Content>
            <Modal.Actions className="d-flex justify-content-center">
                <Button secondary className="borderRadius w-25 ml-0" size='small' onClick={() => props.openOrClosePunchesModal({ modalOpenStartAndLunchTime: false })}>Back</Button>
            </Modal.Actions>
            {props.isShowLoader && <Loader />}
        </Modal>
    )
}

export default PunchesModal;